import React, {useEffect, useState} from "react";

import _ from "lodash";
import MaterialTable from "@material-table/core";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
  Button,
  Grid,
  IconButton
} from "@material-ui/core";
import {DeleteForever, Edit, ErrorOutline} from "@material-ui/icons";
import {Autocomplete} from "@material-ui/lab";
import {tableIcons} from "../../ui-components/TableIcons";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";

//TODO: missing gabriele.grana@kerakoll.com id_referente 95 admin
// andrea.bicocchi@kerakoll.com 373 admin
// federica.bruni@kerakoll.com 405 admin
// filippo.simoni@kerakoll.com 105 admin
// alessio.miozzi@kerakoll.com 412 admin
// davide.campanini@kerakoll.com 97 admin

const OPTIONS = {
  filtering: true,
  showTitle: false,
  pageSize: 10,
  headerStyle: {padding: 12, whiteSpace: "nowrap"},
  filterCellStyle: {padding: 12, maxWidth: 400},
};

const LOCALIZATION = {
  body: {
    editTooltip: "Modifica",
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} di {count} temi",
    labelRowsSelect: "Temi",
  }
};

const renderTemiEMacro = (rowData, scope, setWorkingRow) => {
  return <>
    <span style={{lineHeight: 2, marginRight: 20}}>{rowData[scope]}</span>
    <IconButton
      style={{float: "right", padding: 2}}
      onClick={() => setWorkingRow({rowData: rowData, scope: scope, action: "delete"})}>
      <DeleteForever/>
    </IconButton>
    <IconButton
      style={{float: "right", padding: 2}}
      onClick={() => setWorkingRow({rowData: rowData, scope: scope, action: "edit"})}>
      <Edit color="primary"/>
    </IconButton>
  </>
}

const renderReferente = (rowData, referenti, setWorkingRow) => {
  return <>
    <span style={{lineHeight: 2, marginRight: 20}}>{referenti[rowData['id_referente']]}</span>
    <IconButton
      style={{float: "right", padding: 2}}
      onClick={() => setWorkingRow({rowData: rowData, scope: 'referente', action: "edit"})}>
      <Edit color="primary"/>
    </IconButton>
  </>
}

const getColumns = (vertical, macrotemi, referenti, setWorkingRow) => {
  return [
    {title: "Vertical", field: "vertical", lookup: vertical},
    {
      title: "Macrotema", field: "macrotema", lookup: macrotemi,
      render: rowData => renderTemiEMacro(rowData, "macrotema", setWorkingRow),
      headerStyle: {minWidth: 250},
      cellStyle: {minWidth: 250}
    },
    {
      title: "Referente", field: "id_referente", lookup: referenti,
      render: rowData => renderReferente(rowData, referenti, setWorkingRow),
      headerStyle: {minWidth: 200},
      cellStyle: {minWidth: 200}
    },
    {
      title: "Tema", field: "tema",
      render: rowData => renderTemiEMacro(rowData, 'tema', setWorkingRow),
      headerStyle: {minWidth: 300},
      cellStyle: {minWidth: 300}
    },
    {
      title: "Visibilità",
      field: "riservato_kerakoll",
      lookup: {1: "Interni", 2: "Agenti", 3: "Tutti"},
      headerStyle: {minWidth: 80, maxWidth: 80, width: 80},
      cellStyle: {minWidth: 80, maxWidth: 80, width: 80}
    },
    {title: "Domande", field: "question_count", filtering: false}
  ];
}

const EMPTY = {rowData: {}, scope: "", action: ""}


function TripletsList({triplets, adminsOptions, openAlert, setTriplets, toggleOpenDialog}) {

  const [loading, setLoading] = useState(false);
  const [workingRow, setWorkingRow] = useState(EMPTY);
  const [selectedReferent, setSelectedReferent] = useState();
  const [macrotemaDeletable, setMacrotemaDeletable] = useState(false);
  const [temaDeletable, setTemaDeletable] = useState(false);
  const [newName, setNewName] = useState();
  const [canSend, setCanSend] = useState(false);
  const apiRequestCountry = useCountryAxiosInstance();


  // console.log('triplets', triplets)

  // console.log('selectedReferent', selectedReferent)

  useEffect(() => {
    if (workingRow.scope === 'referente') {
      setSelectedReferent(adminsOptions.filter(i => i.id === workingRow.rowData.id_referente)[0])
    }
    if (workingRow.scope === 'macrotema' && workingRow.action === 'delete') {
      const macrotemaQuestionCount = triplets
        .filter(i => i.macrotema === workingRow.rowData.macrotema)
        .reduce((acc, j) => acc + j.question_count, 0)
      setMacrotemaDeletable(macrotemaQuestionCount === 0)
      setCanSend(macrotemaQuestionCount === 0)
    }
    if (workingRow.scope === 'tema' && workingRow.action === 'delete') {
      const temaQuestionCount = triplets
        .filter(i => i.tema === workingRow.rowData.tema)
        .reduce((acc, j) => acc + j.question_count, 0)
      setTemaDeletable(temaQuestionCount === 0)
      setCanSend(temaQuestionCount === 0)
    }
  }, [workingRow]) // eslint-disable-line react-hooks/exhaustive-deps

  const referenteReducer = (accumulator, currentObj) => {
    accumulator[currentObj['id']] = `${currentObj['firstname']} ${currentObj['lastname']}`
    return accumulator
  }

  const vertical = triplets ? [...new Set(triplets.map(i => i['vertical']))].sort().reduce((o, key) => ({
    ...o,
    [key]: key
  }), {}) : {}
  const macrotemi = triplets ? [...new Set(triplets.map(i => i['macrotema']))].sort().reduce((o, key) => ({
    ...o,
    [key]: key
  }), {}) : {}
  const referenti = adminsOptions ? [...new Set(adminsOptions)].sort().reduce(referenteReducer, {}) : {}

  const reset = () => {
    setWorkingRow(EMPTY)
    setCanSend(false)
    setNewName(undefined)
    setSelectedReferent(undefined)
  }

  const handleReferent = (e, v) => {
    setSelectedReferent(v)
    setCanSend(true)
  }

  useEffect(() => {
    setCanSend(newName !== undefined && newName !== "")
  }, [newName])

  function getIdList(scope) {
    let idList = []
    if (scope === 'macrotema') {
      triplets.forEach(i => {
        if (i.macrotema === workingRow.rowData.macrotema) {
          idList = idList.concat(i.question_ids)
        }
      })
    } else {
      triplets.forEach(i => {
        if (i.macrotema === workingRow.rowData.macrotema && i.tema === workingRow.rowData.tema) {
          idList = idList.concat(i.question_ids)
        }
      })
    }
    return idList
  }

  function getUpdateData(scope) {
    if (scope === 'macrotema') {
      return {
        "script": {
          "source": "ctx._source.macrotema = params.macrotema",
          "lang": "painless", "params": {"macrotema": newName}
        }
      }
    } else {
      return {
        "script": {
          "source": "ctx._source.tema = params.tema",
          "lang": "painless", "params": {"tema": newName}
        }
      }
    }
  }

  function updateThemeFile(header) {

    apiRequestCountry.post('/assistant/update_themes', header)
      .then((result) => {
        setTriplets(undefined)
        openAlert("success", "Modifiche salvate con successo")
      })
      .catch((err) => {
        openAlert("error", "Errore imprevisto durante la modifica")
      })
      .finally(() => {

        setLoading(false)
        reset()
      })

  }

  const handleSend = () => {
    setLoading(true)
    if (workingRow.action === 'delete') {
      let header = {macrotema: workingRow.rowData.macrotema, tema: ''}
      if (workingRow.scope === 'tema') {
        header['tema'] = workingRow.rowData.tema
      }

      apiRequestCountry.delete('/assistant/themes', {"data": header})
        .then((result) => {    //
          if (workingRow.scope === 'tema') {
            setTriplets(triplets.filter(i => i.macrotema !== header.macrotema || i.tema !== header.tema))
          } else {
            setTriplets(triplets.filter(i => i.macrotema !== header.macrotema))
          }
          openAlert("success", "Elemento eliminato correttamente")
        })
        .catch((err) => {
          openAlert("error", "Errore imprevisto durante la cancellazione")
        })
        .finally(() => {
          setLoading(false)
          reset()
        })

    } else {

      if (workingRow.scope !== 'referente') {
        let updateData = getUpdateData(workingRow.scope)
        let idList = getIdList(workingRow.scope)

        const promises = idList.map(i => apiRequestCountry.post(`/assistant/update_with_script`, {
          "doc_script": updateData,
          "doc_id": i
        }))

        Promise.all(promises).then(() => {
          let header = {
            macrotema: workingRow.rowData.macrotema,
            field: workingRow.scope,
            value: newName
          }
          if (workingRow.scope === 'tema') {
            header['tema'] = workingRow.rowData.tema
          }
          updateThemeFile(header)
        })
      } else {
        const header = {
          macrotema: workingRow.rowData.macrotema,
          field: 'id_referente',
          value: selectedReferent['id']
        }
        updateThemeFile(header)
      }
    }
  }

  return (
    <>

      <MaterialTable
        columns={getColumns(vertical, macrotemi, referenti, setWorkingRow)}
        data={triplets}
        icons={tableIcons}
        isLoading={!triplets || !adminsOptions || triplets.length === 0}
        options={OPTIONS}
        localization={LOCALIZATION}
        style={{marginTop: 15, marginBottom: 20}}
        actions={[{
          icon: tableIcons.Add,
          onClick: () => {
            toggleOpenDialog()
          },
          isFreeAction: true,
          tooltip: 'Aggiungi tema'
        }]}
      />
      <Dialog open={workingRow.action !== ""} onClose={reset}>
        <DialogTitle>
          {workingRow.action === 'delete' ? "Cancellazione" : "Modifica"} {workingRow.scope}
        </DialogTitle>

        {workingRow.scope === 'referente' &&
        <>
          <DialogContent>
            <p>Selezione un nuovo referente per il macrotema <b>{workingRow.rowData.macrotema}</b></p>
            <Autocomplete
              value={selectedReferent || null}
              options={adminsOptions}
              getOptionLabel={(i) => `${i['firstname']} ${i['lastname']}`}
              renderOption={(i) => `${i['firstname']} ${i['lastname']}`}
              onChange={handleReferent}
              style={{minWidth: 350, marginTop: 20, marginBottom: 20}}
              renderInput={(params) => (
                <TextField {...params} label="Seleziona il referente" variant="outlined"/>
              )}
            />
          </DialogContent>
        </>
        }
        {(workingRow.scope === 'macrotema' || workingRow.scope === 'tema') && workingRow.action === 'edit' &&
        <>
          <DialogContent>
            <p>Vuoi rinominare il {workingRow.scope} <b>{workingRow.rowData[workingRow.scope]}</b>?</p>
            <TextField
              label="Inserisci il nuovo nome"
              variant="outlined"
              style={{width: "100%"}}
              onChange={(e) => setNewName(e.target.value)}
            />
          </DialogContent>
        </>
        }
        {workingRow.scope === 'macrotema' && workingRow.action === 'delete' &&
        <>
          <DialogContent>
            {macrotemaDeletable
              ? <p>Stai per eliminare il macrotema <b>{workingRow.rowData.macrotema}</b></p>
              : <Grid container style={{marginTop: 15}}>
                <Grid item xs={1}><ErrorOutline color="primary"/></Grid>
                <Grid item xs={11}>
                  <p>
                    Non è possibile eliminare il macrotema <b>{workingRow.rowData.macrotema}</b> poichè sono
                    presenti domande all'interno dei temi sottostanti.
                  </p>
                </Grid>
              </Grid>
            }
          </DialogContent>
        </>
        }
        {workingRow.scope === 'tema' && workingRow.action === 'delete' &&
        <>
          <DialogContent>
            {temaDeletable
              ? <p>Stai per eliminare il tema <b>{workingRow.rowData.tema || "vuoto"}</b> del
                macrotema <b>{workingRow.rowData.macrotema}</b></p>
              : <Grid container style={{marginTop: 15}}>
                <Grid item xs={1}><ErrorOutline color="primary"/></Grid>
                <Grid item xs={11}>
                  <p>
                    Non è possibile eliminare il tema <b>{workingRow.rowData.tema}</b> poichè sono
                    presenti domande all'interno. Eliminarle o spostarle sotto altri temi per poter procedere.
                  </p>
                </Grid>
              </Grid>
            }
          </DialogContent>
        </>
        }
        <DialogContent>
          <div style={{textAlign: "center", marginTop: 10}}>
            <Button onClick={reset} variant="contained" style={{float: "left", marginBottom: 10}}>
              Chiudi
            </Button>
            {loading && <CircularProgress style={{marginLeft: "auto", marginRight: "auto"}}/>}
            <Button
              onClick={handleSend}
              disabled={!canSend}
              color="primary" variant="contained" style={{float: "right", marginBottom: 10}}
            >
              Invia
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default React.memo(TripletsList, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.triplets, nextProps.triplets);


})